<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div *ngIf="payload?.properties?.text?.value">
  <label class="flex jcc">
    <span [innerHTML]="payload?.properties.text?.value | tokenToDiv"></span>
  </label>
</div>
<div *ngIf="payload?.properties?.content?.value">
  <label class="flex jcc" style="font-weight: 400">
    <span [innerHTML]="payload?.properties.content?.value | tokenToDiv"></span>
  </label>
</div>

<div class="flex" class="content richedit-preview" *ngIf="!selected">
  <div [innerHtml]="html | async" class="check_deploy"></div>
</div>

<div class="richedit-editor" *ngIf="selected">
  <rx-richedit
    #propertyDynamic2
    class="flex"
    [(ngModel)]="payload.properties.value.value"
    [includeToolBar]="true"
  ></rx-richedit>
</div>
